export const OB_STEPS = {
  EMAIL: 2,
  COMPANY: 3,
  INTEGRATION: 4,
  ENROLLMENT: 5,
  ALERTS: 6,
  CARD: 7,
  TOP_UP: 8
}

// The product choice is not a backend step (OB-X-05) but is shown and counted like one (OB-3-06):
// it slots in right after the email, before the steps the backend tracks.
export const FEATURES_CHECKLIST_ITEM = {
  step: "FEATURES",
  title: "Choose your features",
  description: "Pick Prevent, Recover, or both",
  isDivider: true
}

export const onboardingSteps = [
  (email, isEdit, isVerify) => ({
    id: 1,
    step: OB_STEPS.EMAIL,
    title: "Email verification",
    description: email,
    isEdit,
    isVerify
  }),
  {
    id: 2,
    step: OB_STEPS.COMPANY,
    title: "Company profile",
    description: "Enter your business name and website URL",
    continue: "onboarding/business-info",
    isDivider: true
  },
  {
    id: 3,
    step: OB_STEPS.INTEGRATION,
    title: "Connect integration",
    description: "Connect Stripe, Shopify, or other processors",
    isDivider: true
  },
  {
    id: 4,
    step: OB_STEPS.ENROLLMENT,
    title: "Choose enrollment",
    description: "Turn on Ethoca, RDR, or CDRN coverage",
    isDivider: true
  },
  {
    id: 5,
    step: OB_STEPS.ALERTS,
    title: "Activate alerts",
    description: "Provide your billing descriptors and ARN codes (or BIN & CAID)",
    isDivider: true
  },
  {
    id: 6,
    step: OB_STEPS.CARD,
    title: "Link a card",
    description: "Enter your card details.",
    isDivider: true
  },
  {
    id: 7,
    step: OB_STEPS.TOP_UP,
    title: "Top up your balance",
    description: "Add funds to activate your chargeback protection."
  }
]
